import React, { Component } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

class SharingTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLogo: true,
      showAvailability: true,
      requirePhone: false
    };
  }

  render() {
    const { estimateUrl, linkCopied, onCopyLink, onDownloadQR } = this.props;
    const { showLogo, showAvailability, requirePhone } = this.state;

    return (
      <>
        {/* Estimate Page */}
        <div className="card mb-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">
              <i className="fa-sharp fa-regular fa-share-nodes mr-2"></i>
              Estimate Page
            </h4>
            <a
              href={estimateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-outline-success"
            >
              <i className="fa-sharp fa-regular fa-external-link-alt mr-1"></i>
              Preview
            </a>
          </div>
          <div className="card-body">
            <div className="row align-items-center">
              {/* QR Code */}
              <div className="col-md-4 text-center mb-3 mb-md-0">
                <QRCodeCanvas
                  id="estimate-qr-code"
                  value={estimateUrl}
                  size={180}
                  level="M"
                  includeMargin={true}
                />
                <div className="mt-2">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onDownloadQR}
                  >
                    <i className="fa-sharp fa-regular fa-download mr-1"></i>
                    Download QR Code
                  </button>
                </div>
              </div>

              {/* Shareable Link */}
              <div className="col-md-8">
                <label className="font-weight-bold mb-1">Your Estimate Page Link</label>
                <div className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={estimateUrl.replace(/^https?:\/\//, '')}
                    readOnly
                    onClick={(e) => e.target.select()}
                  />
                  <div className="input-group-append">
                    <button
                      className={`btn ${linkCopied ? 'btn-success' : 'btn-primary'}`}
                      onClick={onCopyLink}
                    >
                      <i className={`fa-sharp fa-regular ${linkCopied ? 'fa-check' : 'fa-copy'} mr-1`}></i>
                      {linkCopied ? 'Copied!' : 'Copy Link'}
                    </button>
                  </div>
                </div>
                <small className="text-muted">
                  Share this link on business cards, shop signage, social media, or anywhere customers can find you.
                  The QR code links to the same page.
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Public Page Appearance (placeholder) */}
        <div className="card mb-4">
          <div className="card-header">
            <h4 className="mb-0">
              <i className="fa-sharp fa-regular fa-palette mr-2"></i>
              Public Page Appearance
            </h4>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="showLogoToggle"
                  checked={showLogo}
                  onChange={(e) => this.setState({ showLogo: e.target.checked })}
                />
                <label className="custom-control-label" htmlFor="showLogoToggle">
                  Show company logo on estimate page
                </label>
              </div>
            </div>
            <div className="mb-3">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="showAvailabilityToggle"
                  checked={showAvailability}
                  onChange={(e) => this.setState({ showAvailability: e.target.checked })}
                />
                <label className="custom-control-label" htmlFor="showAvailabilityToggle">
                  Show next available date
                </label>
              </div>
            </div>
            <div className="mb-3">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="requirePhoneToggle"
                  checked={requirePhone}
                  onChange={(e) => this.setState({ requirePhone: e.target.checked })}
                />
                <label className="custom-control-label" htmlFor="requirePhoneToggle">
                  Require phone verification
                </label>
              </div>
            </div>
            <p className="text-muted small mb-0">
              <i className="fa-sharp fa-regular fa-info-circle mr-1"></i>
              Appearance settings will be saved automatically once this feature is fully available.
            </p>
          </div>
        </div>

      </>
    );
  }
}

export default SharingTab;
